module.exports = __webpack_public_path__ + "img/ballon-cultura.25bce835.png";